// extracted by mini-css-extract-plugin
export default {"container":"BrowsePage_container__5Xj+k","content":"BrowsePage_content__BaS8b"};